module.exports = __webpack_public_path__ + "img/livro.d37ed245.png";